export default __webpack_public_path__ + "static/media/white-arrow-drop-down.44a0b743.svg";